import script from "./FlowerPay.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlowerPay.vue?vue&type=script&lang=ts&setup=true"

import "./FlowerPay.vue?vue&type=style&index=0&id=3146d565&lang=scss&scoped=true"

import exportComponent from "I:\\cto\\mysoft\\gitee\\zhaoxi-flower-ui\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3146d565"]])

export default __exports__